/* global $ google App formidable*/
import "../../css/app/components/home.scss";
import "../../css/app/components/getaprice.scss";
import(/* webpackChunkName: "slick" */ '../components/slick');
class Getprice
{
    constructor () 
    {
        console.log('Get Price initialised');
        
        this.pendingFinalAction = null;
        this.bindFormidableSuccess();
        
        var _this = this;
        var inputPostcode = "";
        const queryString = window.location.search;
        if(queryString){
            const urlParams = new URLSearchParams(queryString);
            if(urlParams.has('quoteRef')){
                console.log('quote ref found');
                _this.fetchQuoteByRef(urlParams.get('quoteRef'));
            }
        }

        $('#find-address').on('click', function(){
            inputPostcode = $('#postcode').val();
            _this.findNearestLocations(inputPostcode);
        });
        $('#select-location').on('change', function() {
            _this.selectLocation($('#select-location').val());
        });
        if ($('#get-a-price-field-billing-postcode-input').length)
        {
            $('#get-a-price-field-billing-postcode-input').on('click', function() {
                alert(this.val());
            });
        } 
        $('#step-btn').on('click', function(){
            _this.goToStep2();
        });

        $('#get-price-submit').on('click', function(e) {
            if($('.quote-option-check-input:checked').val() === '' || $('#get-a-price-field-start-date-input').val() === '')
            {
                e.preventDefault();
                return false;
            }
        });
            
        this.initSelect2();
    }

    bindFormidableSuccess()
    {
        var _this = this;
        var form = document.getElementById('formidable_get_a_price');

        if (!form) {
            return;
        }

        form.addEventListener('formidable.validation.success', function() {
            if (!_this.pendingFinalAction) {
                return;
            }

            var action = _this.pendingFinalAction;
            _this.pendingFinalAction = null;

            $('#loading-step6').html('Please wait ..');

            if (action.type === 'reserve-now') {
                _this.submitPricing(action.values);
            } else {
                _this.payPricing(action.values);
            }
        });
    }

    buildFinalSubmissionValues()
    {
        var values = "";
        var $inputs = $('#formidable_get_a_price :input');
        var quoteType = $('.quote-option-check-input:checked').val();

        $inputs.each(function() {
            if (this.type == "checkbox" && $(this).prop("checked") == false) {
                $(this).val('0');
            }

            if (this.id) {
                values += '&' + this.id + '=' + this.value;
            } else {
                values += '&' + this.name + '=' + this.value;
            }
        });

        values += '&quoteType=' + quoteType;

        if ($('#get-a-price-field-photo-id-input').get(0).files.length > 0) {
            var photoIDSize = $('#get-a-price-field-photo-id-input').get(0).files[0].size;
            values += '&photoIdSize=' + photoIDSize;
        }

        if ($('#get-a-price-field-proof-of-address-input').get(0).files.length > 0) {
            var addressProofSize = $('#get-a-price-field-proof-of-address-input').get(0).files[0].size;
            values += '&addressProofSize=' + addressProofSize;
        }

        return values.replace(/^&/, "");
    }

    triggerSubmit()
    {
        var _this = this;
        var quoteType = $('.quote-option-check-input:checked').val();
        var initialAmount = $('#get-a-price-field-initial-amount').val().replace('Â£', '');
        var actionType = (quoteType == 'reserve-now' && Math.round(initialAmount) == '0') ? 'reserve-now' : 'pay';

        _this.pendingFinalAction = {
            type: actionType,
            values: _this.buildFinalSubmissionValues()
        };

        $('#get-price-submit').attr('disabled', false).trigger('click');
        $('#get-price-submit').attr('disabled', true);
        $('#pay-btn-content').css('pointer-events', 'none');
    }

    findNearestLocations(inputPostcode)
    {
        const locations = $('#find-address').data('locations').split(', ');
        var geocoder = new google.maps.Geocoder();
        var _this = this;
        geocoder.geocode({ 'address': inputPostcode }, function (results, status) {
            if (status == google.maps.GeocoderStatus.OK) {
                var inputLatitude = results[0].geometry.location.lat();
                var inputLongitude = results[0].geometry.location.lng();
                var inputLatlng = new google.maps.LatLng(inputLatitude, inputLongitude);
            }
            let distanceArr = [];
            for(let i in locations){
                const loc = locations[i].split(':');
                let key = loc[0];
                let postcode = loc[1];
                console.log(key + ' -> ' + postcode);
                geocoder.geocode({ 'address': postcode }, function (results, status) {
                    if (status == google.maps.GeocoderStatus.OK) {
                        var latitude = results[0].geometry.location.lat();
                        var longitude = results[0].geometry.location.lng();
                    }
                
                    var p2 = new google.maps.LatLng(latitude, longitude);
                    let distance = (google.maps.geometry.spherical.computeDistanceBetween(inputLatlng, p2) * 0.000621371).toFixed(2);
                    distanceArr.push({ 'key': key, 'distance': distance });
                    _this.getShortestDistance(inputPostcode, locations, distanceArr);
                });
            }

        });
        
    }

    getShortestDistance(inputPostcode, locations, distanceArr)
    {
        var _this = this;
        if(distanceArr.length == locations.length)
        {
            distanceArr.sort(function(a, b){return a.distance - b.distance});
            console.log(distanceArr.length + ' ' + distanceArr[0].key);
            var locationId = distanceArr[0].key;
            var distance = distanceArr[0].distance;
            $.ajax({
                type: 'get',
                url: '/getnearestlocation',
                dataType: 'json',
                data: {locationId: locationId, distance: distance, inputPostcode: inputPostcode},
                processData: true,
                success: function(response){
                    $('#selected-location').html(response.locationHtml);
                    $('#location-image').html(response.imageHtml);
                    $('#location-phone').html(response.locationPhone);

                    $('#select-location-btn').on('click', function(){
                        $('#locationId').val(locationId);
                        $('#select-location-btn').html('location selected');
                        _this.selectLocation(locationId);
                    });
                },
                error: function(){

                }
            });
        }
    }

    selectLocation(locationId)
    {
        var _this = this;
        $('.step-btn').html("<span class='text-red'>Please wait ...</span>");
        $.ajax({
            type: 'get',
            url: '/getnearestlocation',
            dataType: 'json',
            data: {locationId: locationId, distance: '', inputPostcode: ''},
            processData: true,
            success: function(response){
                $('#locationId').val(locationId);
                $('#location-options').html(response.locationOptionHtml);
                $('#selected-location').html('');
                $('#location-image').html(response.imageHtml);
                $('#location-phone').html(response.locationPhone);
                $('#get-a-price-field-location').val(response.locationTitle);
                setTimeout(() => {   
                    $('.step-btn').html("<span id='step-btn' class='btn btn-secondary'>next step</span>");
                    $('#step-btn').on('click', function(){
                        _this.goToStep2();
                    });
                }, 500);
                
                $('#select-location').on('change', function() {
                    _this.selectLocation($('#select-location').val());
                });
            },
            error: function(){
            }
        });
    }

    goToStep2()
    {
        var _this = this;
        if($('#locationId').val()){
            $('#step-2').html("<span class='text-red'>Please wait ...</span>");
            _this.showUnitSizes($('#locationId').val());
            $('#step-2').removeClass('d-none').addClass('d-block');
            $('#step-1').addClass('d-none');
            $('#indicator-1').removeClass('active').addClass('step-done');
            $('#indicator-2').removeClass('next-step').addClass('active');
            $('.stepcol-1').addClass('step-done');
            $("html, body").animate({ scrollTop: $('#step-2').offset().top -130}, 'slow');
        }
        else{
            alert('Please select a location first.');
        }
    }

    showUnitSizes(locationId){
        var _this = this;
        $.ajax({
            type: 'get',
            url: '/showStep2',
            dataType: 'html',
            data: {locationId: locationId},
            processData: true,
            success: function(response){
                $('#step-2').html(response);
                $('#step-2').removeClass('d-none').addClass('d-block');
                if($('.unit-size').length){
                    $('.unit-size-carousal').slick({
                        slidesToShow: 2,
                        slidesToScroll: 1,
                        arrows: true,
                        fade: false,
                        rows: 0,
                        infinite: false,
                        responsive: [
                            {
                                breakpoint: 992,
                                settings: {
                                    slidesToShow: 1
                                }
                            }
                        ]
                    });
                    $('.unit-size').each(function(){
                        $(this).on('click', function(){
                            var id = this.id;
                            $('#unitId').val(id);
                            _this.showStep3(locationId, id);
                        });
                    });
                    $('.unit-size-carousal').on('afterChange', function(){
                        var currentUnit = parseInt(($(this).find('.slick-current').attr('data-slick-index'))) + 1;
                        var cardType = $(this).find('.slick-current').attr('data-type');
                        $('#current-unit-no').html(currentUnit);
                        if (cardType === 'special-card') {
                            $('#unit-counter').css('opacity', '0');
                        } else {
                            $('#unit-counter').css('opacity', '1');
                        }
                    })
                }
                $('#back-btn-step-2').on('click', function(){
                    _this.goBack('step-2','step-1');
                });
            },
            error: function(){
                alert('error');
            }
        });
    }

    fetchQuoteByRef(quoteRef)
    {
        var _this = this;
        $('#step-1').removeClass('d-block').addClass('d-none');
        $('#loading-steps').removeClass('d-none').addClass('d-block');
        $.ajax({    
            type: 'get',
            url: '/fetchQuoteByRef',
            dataType: 'json',
            data: {quoteRef: quoteRef},
            processData: true,
            success: function(response){
                if(response.error) {
                    alert('Sorry, we could not find a quote with this reference. Please check the reference and try again.');
                    window.location.href = '/get-a-price';
                } else {
                    $('#indicator-1').removeClass('active').addClass('step-done');
                    $('#indicator-2').addClass('step-done');
                    $('#indicator-3').addClass('step-done');
                    $('#indicator-4').removeClass('next-step').addClass('active');
                    $('#get-a-price-field-locationId').val(response.locationID);
                    $('#get-a-price-field-unit-sizeId').val(response.unitID);
                    $('#get-a-price-field-unit-size').val(response.unit);
                    $('#get-a-price-field-location').val(response.location);
                    $('#get-a-price-field-title-input').val(response.namePrefix);
                    $('#get-a-price-field-first-name-input').val(response.fname);
                    $('#get-a-price-field-last-name-input').val(response.lname);
                    $('#get-a-price-field-email-input').val(response.email);
                    $('#get-a-price-field-phone-input').val(response.phone);
                    $('#get-a-price-field-storage-duration-input').val(response.durationID);
                    _this.showStep4(response.locationID, response.unitID, 0, 0, '');
                }
            },
            error: function(){
                alert('Invalid quote reference.');
            }
        });
    }
            
    showStep3(locationId, unitId, duration = '')
    {
        var _this = this;
        $('#indicator-2').removeClass('active').addClass('step-done');
        $('#indicator-3').removeClass('next-step').addClass('active');
        $('.stepcol-2').addClass('step-done');
        var formidableForm = formidable.getForm('formidable_get_a_price');
        $.ajax({
            type: 'get',
            url: '/showStep3',
            dataType: 'json',
            data: {locationId: locationId, unitId: unitId, duration: duration},
            processData: true,
            success: function(response){
                $('#step-3-left-col').html(response.left_col_html);
                $('#get-a-price-field-locationId').val(locationId);
                $('#get-a-price-field-discount-code').find('.instructions').addClass('bg-info text-white p-3 position-absolute top-0 end-0');
                $('#get-a-price-field-unit-sizeId').val(unitId);
                $('#get-a-price-field-unit-size').val(response.unit_size);
                $('#get-a-price-field-location').val(response.location_name);
                $('#storageDurationOptions').html(response.storageDurationOptions);
                $('#step-3').removeClass('d-none').addClass('d-block');
                $('#step-2').removeClass('d-block').addClass('d-none');
                $("html, body").animate({ scrollTop: $('#step-3').offset().top -130}, 'slow');
                $('#back-btn-step-3').on('click', function(){
                    _this.goBack('step-3','step-2');
                });
                $('#get-a-price-field-phone-input').on('input', function () {
                    _this.formatPhoneField(this);
                });
                $('#get-a-price-field-discount-code').find('.instructions').on('click', function() {
                    _this.verifyCoupon();
                });

                $('#submit-step-3').off("click").on('click', function(e){
                    e.preventDefault();
                    if (formidableForm.validateGroup($(this).data('group'))){
                        if (_this.validateEmail($('#get-a-price-field-email-input').val())) {
                            //_this.submitQuoteData();
                            $('#get-a-price-field-storage-duration-input').val($('#storage-duration-input').val());
                            $('#get-a-price-field-duration-of-storage').val($('#storage-duration-input option:selected').text());
                            $('#loading-step4').html('please wait ...');
                            _this.showStep4($('#get-a-price-field-locationId').val(), $('#get-a-price-field-unit-sizeId').val(), '1', '0', response.quote_token);
                        } else {
                            $('#get-a-price-field-email').find('.errors').html("<div class='invalid-feedback'>Please enter a valid email address.</div>");
                        }
                    }
                    else{
                        alert('please fill in the fields first');
                    }
                });
            },
            error: function(){
                alert('error');
            }
        });
    }

    submitQuoteData()
    {
        console.log('quote form called');
        $("#quote-field-quote-title-input").val($('#get-a-price-field-title-input').val());
        $("#quote-field-quote-first-name-input").val($('#get-a-price-field-first-name-input').val());
        $("#quote-field-quote-last-name-input").val($('#get-a-price-field-last-name-input').val());
        $("#quote-field-quote-phone-input").val($('#get-a-price-field-phone-input').val());
        $("#quote-field-quote-email-input").val($('#get-a-price-field-email-input').val());
        $("#quote-field-quote-duration-input").val($('#select2-get-a-price-field-storage-duration-input-container').attr('title'));
        $("#quote-field-quote-location-input").val($('#get-a-price-field-location').val());
        $("#quote-field-quote-unit-size-input").val($('#get-a-price-field-unit-size').val());
        $('.quote-only').attr('disabled', false);
        $('.quote-only').trigger('click');
    }

    verifyCoupon()
    {
        var discountCode = $('#get-a-price-field-discount-code-input').val();
        $.ajax({
            type: 'get',
            url: '/verifyCoupon',
            dataType: 'json',
            data: {discountCode: discountCode},
            processData: true,
            success: function(response){
                if(response.coupon_validity == true)
                {
                    $('#get-a-price-field-discount-code').find('.instructions').html('coupon applied');
                    $('#get-a-price-field-discount-code').find('.errors').html('');
                    $('#code-validity').val('valid');
                }
                else
                {
                    $('#get-a-price-field-discount-code').find('.errors').html("<span class='text-danger'>coupon code is invalid</span>");
                    $('#code-validity').val('');
                }
            },
            error: function(){
                alert('error');
            }
        });
    }

    showStep4(locationId, unitId, getQuote=0, radioClicked=0, quoteToken='')
    {
        var _this = this;
        $('#indicator-3').removeClass('active').addClass('step-done');
        $('#indicator-4').removeClass('next-step').addClass('active');
        $('.stepcol-3').addClass('step-done');
        var duration = $('#get-a-price-field-storage-duration-input').val();
        var title = $('#get-a-price-field-title-input').val();
        var fname = $('#get-a-price-field-first-name-input').val();
        var lname = $('#get-a-price-field-last-name-input').val();
        var email = $('#get-a-price-field-email-input').val();
        var phone = $('#get-a-price-field-phone-input').val();

        $.ajax({
            type: 'get',
            url: '/showStep4',
            dataType: 'json',
            data: {locationId: locationId, unitId: unitId, duration: duration, title: title, fname: fname, lname: lname, email: email, phone: phone, getQuote: getQuote, quotekey: quoteToken},
            processData: true,
            success: function(response){
                var offerValue = response.offer_value;
                $('#step-4-box-1').html(response.unitHtml);
                $('#step-4-box-3').html(response.other_units_html);
                $('#step-4-box-4').html(response.selected_location_html);
                $('#reservation-price').html(response.reservation_price_html);
                if(response.effectiveAailableUnits == 0) {
                    $('#availability-msg').html(response.notEnoughUnitMessage);
                    $('#availability-msg').removeClass('d-none').addClass('d-block');
                    $('#quote-type').removeClass('d-block').addClass('d-none');
                }
                else {
                    $('#availability-msg').removeClass('d-block').addClass('d-none');
                    $('#quote-type').removeClass('d-none').addClass('d-block');
                }
                $('#get-a-price-field-unit-size').val(response.unit_size);
                $('#step-3').removeClass('d-block').addClass('d-none');
                $('#step-4').removeClass('d-none').addClass('d-block');
                $("html, body").animate({ scrollTop: $('#step-4').offset().top -130}, 'slow');
                $('.other-unit-size-carousal').slick({
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    arrows: true,
                    fade: false,
                    rows: 0,
                    infinite: false,
                    responsive: [
                        {
                            breakpoint: 992,
                            settings: {
                                slidesToShow: 1
                            }
                        }
                    ]
                });
                $('.other-unit').each(function() {
                    var unitId = this.id;
                    $(this).find('.btn').on('click', function() {
                        _this.showStep4(locationId, unitId,'',1, '');
                        console.log(unitId);
                        $('#get-a-price-field-unit-sizeId').val(unitId);
                    });
                });
                $('.other-unit-size-carousal').on('afterChange', function() {
                    var currentUnit = parseInt(($(this).find('.slick-current').attr('data-slick-index'))) + 1;
                    $('#current-other-unit-no').html(currentUnit);
                })
                
                $('#get-a-price-field-quote-option').one('change', function() {
                    var unitID = $('#get-a-price-field-unit-sizeId').val();
                    var quoteType = $('input[type=radio]:checked').val();
                    $('#quote-type').css('pointer-events','none');
                    if(radioClicked == 0) {
                        console.log(unitID + 'kk');
                        if(quoteType=="reserve-now"){
                            _this.showStep5(locationId, unitID, offerValue);
                        }
                        else if(quoteType=="book-and-pay"){
                            setTimeout(() => {   
                                _this.showStep6(locationId, unitID, offerValue);
                            }, 2000);
                        }
                        $('#quote_form').html();
                    }
                });
                $('#loading-steps').removeClass('d-block').addClass('d-none');
                $('#back-btn-step-4').on('click', function(){
                    _this.goBack('step-4','step-3');
                });
            },
            error: function(){
                alert('error');
            }
        });

    }

    showStep5(locationId, unitId, offerValue)
    {
        var _this = this;
        //$('.body-top').addClass('d-none');
        var duration = $('#get-a-price-field-storage-duration-input').val();
        $.ajax({
            type: 'get',
            url: '/showStep5',
            dataType: 'json',
            data: {locationId: locationId, unitId: unitId, duration: duration, offerValue: offerValue},
            processData: true,
            success: function(response){
                $('#step-4').removeClass('d-block').addClass('d-none');
                var reservationFees = response.reservation_fees;
                $('#step-5-left-col').html(response.location_html);
                $('#summary-price').html(response.summary_price_html);
                
                $('#step-5').removeClass('d-none').addClass('d-block');
                $('#booking-start-date').html('');/* removing the duplicate instance of start date field */
                $('#get-a-price-field-start-date').find('.instructions').addClass('start-date-btn ff-agbook bg-info text-white position-absolute bottom-0 end-0');
                $('#step-5').find('#get-a-price-field-approximate-value').addClass('d-none');
                $("html, body").animate({ scrollTop: $('#step-5').offset().top -130}, 'slow');
                $('#proceed-reservation').off("click").on('click', function() {
                    if($('#get-a-price-field-start-date-input').val() == '')
                    {
                        alert("Please select an approx start date.");
                    }
                    else if(response.free_reservation == true || reservationFees == 0)
                    {
                        _this.triggerSubmit();
                        $('#status-btn').css('pointer-events', 'none');
                        //_this.showReservationForm(locationId, unitId, 'free');
                    }
                    else
                    {
                        _this.showReservationForm(locationId, unitId, '');
                    }
                });
                
            },
            error: function(){
                alert('error');
            }
        });
    }

    showReservationForm(locationId, unitId, chargeType)
    {
        var _this = this;
        $.ajax({
            type: 'get',
            url: '/showReservation',
            dataType: 'json',
            data: {locationId: locationId, unitId: unitId, chargeType: chargeType},
            processData: true,
            success: function(response){
                $('#reservation').html($('#reservation-fields').html());
                setTimeout(() => {
                    $('#reservation-fields').html('');
                    console.log('test');
                }, 2000);
                
                $('#get-a-price-field-billing-postcode').find('.instructions').addClass('postcode-btn ff-agbook bg-info text-white position-absolute bottom-0 end-0');
                $('#reservation').removeClass('d-none').addClass('d-block');
                $('#status-btn').html(response.payment_html);
                if(chargeType == 'free') {
                    $('#billing-address').removeClass('col-md-6');
                    $('#billing-address').removeClass('border-end');
                    $('#payment-details').addClass('d-none');
                    $('#get-a-price-field-initial-amount').val('£0.00');
                }
                else
                {
                    $('#get-a-price-field-initial-amount').val($('#pay-reservation').html().replace('pay ', ''));
                }
                //_this.postcodeLookup();
                
                $('#get-a-price-field-billing-postcode').on('keyup', function(){
                    _this.getAddresses(response.getAddApiKey);
                })
                $('#pay-reservation').on('click', function() {
                    if(_this.validateBillingAddress()){
                        _this.triggerSubmit();
                        $('#status-btn').css('pointer-events', 'none');
                        $('#loading-payment').addClass('d-block').removeClass('d-none');
                    }
                })
                $('#make-reservation').on('click', function() {
                    if(_this.validateBillingAddress()){
                        _this.triggerSubmit();
                        $('#status-btn').css('pointer-events', 'none');
                    }
                })
            },
            error: function(){
                alert('error');
            }
        });
    }

    payPricing(formData)
    {
        $.ajax({
            type: 'get',
            url: '/payPrice',
            dataType: 'json',
            data: formData,
            processData: true,
            success: function(response){
                //alert(response.payment_form);
                $('#payment-form').html(response.payment_form);
                $('#payment-submit').trigger('click');
            },
            error: function(){
                alert('error');
            }
        });
    }

    submitPricing(formData)
    {
        var _this = this;
        var locationId = $('#get-a-price-field-locationId').val();
        var unitId = $('#get-a-price-field-unit-sizeId').val();
        $.ajax({
            type: 'get',
            url: '/submitGetPrice',
            dataType: 'json',
            data: formData,
            processData: true,
            success: function(){
                _this.showThanks(locationId, unitId);
            },
            error: function(){
                alert('error');
            }
        });
    }

    showThanks(locationId, unitId)
    {
        $.ajax({
            type: 'get',
            url: '/showThanks',
            dataType: 'json',
            data: {locationId: locationId, unitId: unitId},
            processData: true,
            success: function(response){
                $('#thanks').html(response.thanks_html);
                $('#step-5').removeClass('d-block').addClass('d-none');
                $('#step-5b').removeClass('d-block').addClass('d-none');
                $('#thanks').removeClass('d-none').addClass('d-block');
                $("html, body").animate({ scrollTop: $('#thanks').offset().top -130}, 'slow');
            },
            error: function(){
                alert('Some unexpected error occured. Please contact system admin.');
            }
        });
    }

    showStep6(locationId, unitId, offerValue)
    {
        var duration = $('#get-a-price-field-storage-duration-input').val();
        var itemValue = $('#get-a-price-field-approximate-value-input').val();
        var _this = this;
        $.ajax({
            type: 'get',
            url: '/showBookAndPay',
            dataType: 'json',
            data: {locationId: locationId, unitId: unitId, duration: duration, itemValue: itemValue, offerValue: offerValue},
            processData: true,
            success: function(response){
                var unitPrice = response.unit_price;
                var offerValue = response.offer_value;
                var refund = response.refund;
                var proofDetails = $('#proof-of-details-fields').html();
                var contractDetails = $('#storage-contract-fields').html();
                var paymentDetails = $('#payment-details-fields').html();
                $('#step-5b-left-col').html(response.location_html);
                $('#summary-price-5b').html(response.summary_price_html);
                $('#booking_value').html(response.booking_summary_html);
                $('#pay-booking').html(response.pay_booking_html);
                $('#pay-booking-btn').html('pay ' + $('#payable-amount').html());
                $('#reservation-start-date').html('');/* removing the duplicate instance of start date field */
                $('#get-a-price-field-initial-amount').val($('#payable-amount').html());
                $('#step-5b').find('#get-a-price-field-start-date').find('.instructions').addClass('start-date-btn bg-info text-white ff-agbook position-absolute bottom-0 end-0');
                $('#step-5b').find('#get-a-price-field-start-date').find('.ff-agbook').html('Start date');
                $('#step-5b').find('#get-a-price-field-start-date-input').addClass('bg-light-gray').removeClass('bg-purple text-white');
                
                _this.getBookingAddressFields();
                
                $('#proof-of-details').html(proofDetails);
                $('#get-a-price-field-photo-id').find('a').addClass('tooltips');
                $('#get-a-price-field-photo-id').find('a').attr('data-bs-title', response.validPhotoIdText);
                $('#get-a-price-field-proof-of-address').find('a').addClass('tooltips');
                $('#get-a-price-field-proof-of-address').find('a').attr('data-bs-title', response.validAddressProofText);
                $('#get-a-price-field-provide-id-on-move-in').removeClass(' row flex-column align-items-center ');
                
                $('#storage-contract-section').html(contractDetails);
                $('#get-a-price-field-accept-terms-and-conditions').removeClass(' row flex-column align-items-center ');
                
                $('#account-details').html(paymentDetails);
                $('#get-a-price-field-authorised-to-setup-dd').removeClass(' row flex-column align-items-center ');
                setTimeout(() => {
                    $('#proof-of-details-fields').html('');
                    $('#storage-contract-fields').html('');
                    $('#payment-details-fields').html('');
                }, 3000);
                $('#step-4').removeClass('d-block').addClass('d-none');
                $('#step-5b').removeClass('d-none').addClass('d-block');
                $("html, body").animate({ scrollTop: $('#step-5b').offset().top -100}, 'slow');
                App.getBootstrap().then((bootstrap) => {
                    const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]');
                    [...tooltipTriggerList].map(tooltipTriggerEl => new bootstrap.Tooltip(tooltipTriggerEl));
                });

                $('#get-a-price-field-approximate-value-input').on('change', function() {
                    _this.resetPaymentSummary(unitId, unitPrice, offerValue, $(this).val(), refund);
                });
                $('#pay-booking-btn').off('click').on('click', function() {
                    if($('#get-a-price-field-start-date-input').val() == '')
                    {
                        alert("Please select an approx start date.");
                    } 
                    else if(_this.validateBillingAddress())
                    {
                        if(($('#get-a-price-field-photo-id-input').get(0).files.length === 0 || $('#get-a-price-field-proof-of-address-input').get(0).files.length === 0) && $('#get-a-price-field-provide-id-on-move-in-input').prop("checked") == false)
                        {
                            alert("You must provide your ID proofs");
                        }
                        else if(($('#get-a-price-field-photo-id-input').get(0).files.length > 0 && $('#get-a-price-field-proof-of-address-input').get(0).files.length > 0) && $('#get-a-price-field-provide-id-on-move-in-input').prop("checked") == true)
                        {
                            alert("Please either upload the IDs or tick to provide them when you move in.");
                        }
                        else if(_this.validateFile())
                        {
                            if($('#get-a-price-field-accept-terms-and-conditions-input').prop("checked") == false)
                            {
                                alert("You must accept the storage contract terms.");
                            }
                            else if(_this.validatePaymentDetails())
                            {
                                _this.triggerSubmit();
                                $('#pay-btn-content').css('pointer-events', 'none');
                            }
                        }
                    }
                });
                $("#scroll-to-address").on('click', function() {
                    $("html, body").animate({ scrollTop: $('#your-address').offset().top -100}, 'slow');
                });
                $("#scroll-to-pay").on('click', function() {
                    $("html, body").animate({ scrollTop: $('#pay-booking').offset().top -100}, 'slow');
                });

                if(!$('#invoice-address').is(':empty')){
                    //_this.postcodeLookup();
                    $('#get-a-price-field-billing-postcode').on('keyup', function(){
                        _this.getAddresses(response.getAddApiKey);
                    })
                }
                
            },
            error: function(){
                alert('error');
            }
        });
    }

    resetPaymentSummary(unitId, unitPrice, offerValue, itemValue, refund)
    {
        $.ajax({
            type: 'get',
            url: '/resetBookingSummary',
            dataType: 'json',
            data: {unitId: unitId, unitPrice: unitPrice, offerValue: offerValue, itemValue: itemValue, refund: refund},
            processData: true,
            success: function(response){
                $('#booking_value').html(response.booking_summary_html);
                $('#get-a-price-field-initial-amount').val($('#payable-amount').html());
                $('#pay-booking-btn').html('pay ' + $('#payable-amount').html());
            },
            error: function(){
                alert('error');
            }
        });
    }

    getBookingAddressFields()
    {
        var _this = this;
        var yourDetails = $('#your-details');
        var invoiceAddress = $('#invoice-address');
        var billingAddressDetails = $('#billing-address').html();
        var userDetails = $('#user-details').html();
        yourDetails.html(userDetails);

        /* copy the values of inputs from step3 */
        yourDetails.find('input').each(function() {
            $(this).val($('#user-details').find('#'+ this.id).val());
            $(this).addClass('bg-light-gray');
        });
        yourDetails.find('#get-a-price-field-title-input').val($('#user-details').find('#get-a-price-field-title-input').val());
        yourDetails.find('#get-a-price-field-storage-duration-input').val($('#user-details').find('#get-a-price-field-storage-duration-input').val());
        yourDetails.find('#get-a-price-field-discount-code').closest('div.bg-gray-800').addClass('d-none');
        yourDetails.find('#get-a-price-field-title').addClass('d-none');
        yourDetails.find('#get-a-price-field-storage-duration').addClass('d-none');
        yourDetails.find('#get-a-price-field-title').parent().removeClass('mb-3');
        yourDetails.find('#get-a-price-field-phone-input').on('input', function () {
            _this.formatPhoneField(this);
        });     
        invoiceAddress.html(billingAddressDetails);
        $('#get-a-price-field-billing-postcode').find('.instructions').addClass('postcode-btn bg-info text-white position-absolute bottom-0 end-0');
        setTimeout(() => {
            $('#user-details').html('');/* removing multiple instance of user details field in step3*/
            $('#billing-address').html('');
        }, 3000);

        invoiceAddress.find('input').each(function() {
            $(this).addClass('bg-light-gray').removeClass('bg-purple text-white');
            $(this).closest('div.label').addClass('text-purple');
        });

    }

    goBack(stepId, prevId)
    {
        var _this = this;
        var currId = stepId.replace('step', 'indicator');
        var prevStepId = prevId.replace('step', 'indicator');
        var prevStepClass = prevId.replace('step', 'stepcol');
        $('#'+prevId).removeClass('d-none').addClass('d-block');
        $('#'+stepId).removeClass('d-block').addClass('d-none');
        $('#' + currId).removeClass('active').addClass('next-step');
        $('#' + prevStepId).removeClass('step-done').addClass('active');
        $('.' + prevStepClass).removeClass('step-done');
        $('#loading-step4').html('');
        if(prevId == 'step-3') {
            var duration = $('#get-a-price-field-storage-duration-input').val();
            _this.showStep3($('#locationId').val(), $('#unitId').val(), duration);
        }
    }

    lookup_samp(postcode){
        const geocoder = new google.maps.Geocoder();

        // Geocode the postcode
        geocoder.geocode({ address: postcode }, (results, status) => {
            if (status === google.maps.GeocoderStatus.OK && results.length > 0) {
                //const address = results[0].formatted_address;
                const address = results[0].address_components
                const location = results[0].geometry.location;
                let components = {};
                address.forEach((addressComponent) => {
                    addressComponent.types.forEach((type) => {
                        components[type] = addressComponent.long_name;
                    });
                });
                // Display the address and location information
                console.log("Address:", address);
                console.log(components['postal_code']);
                console.log("Latitude:", location.lat());
                console.log("Longitude:", location.lng());
                $('#get-a-price-field-billing-address-line-1-input').val(components['street_number']);
                $('#get-a-price-field-billing-address-line-2-input').val(components['route']);
                $('#get-a-price-field-billing-city-input').val(components['postal_town']);
                $('#get-a-price-field-billing-county-input').val(components['administrative_area_level_7']);
            } else {
                console.error("Postcode lookup failed:", status);
            }
        });
    }

    getAddresses()
    {
        var _this = this;
        var postcodeField = $('#get-a-price-field-billing-postcode-input').val();
        $.ajax({
            type: 'get',
            url: '/getAddress',
            dataType: 'json',
            data: {postcode: postcodeField},
            processData: true,
            success: function(response){
                if($('#getAddress-autocomplete-list').length == 0)
                {
                    $('#get-a-price-field-billing-postcode-input').parent().append(response.addressListContainerHtml);
                }
                $('#getAddress-autocomplete-list').html(response.addressListHtml);
                $('.getaddress-suggestion').each(function() {
                    $(this).on('click', function() {
                        var id = $(this).data('id');
                        _this.setBillingAddress(id);
                    });
                    
                })
            },
            error: function(){
                alert('error');
            }
        })
    }

    setBillingAddress(id)
    {
        $.ajax({
            type: 'get',
            url: '/setBillingAddress',
            dataType: 'json',
            data: {addressId: id},
            processData: true,
            success: function(response){

                $('#get-a-price-field-billing-address-line1-input').val(response.addressLn1);
                $('#get-a-price-field-billing-address-line-2-input').val(response.addressLn2);
                $('#get-a-price-field-billing-city-input').val(response.city);
                $('#get-a-price-field-billing-county-input').val(response.county);
                $('#get-a-price-field-billing-zipcode-input').val(response.postcode); 
                $('#get-a-price-field-billing-postcode-input').val(response.postcode);
                $('#getAddress-autocomplete-list').html('');
            },
            error: function(){
                alert('error');
            }
        })
    }

    postcodeLookup()
    {
        var postcodeField = $('#get-a-price-field-billing-postcode-input')[0];
        var autocomplete;
        autocomplete = new google.maps.places.Autocomplete(postcodeField, {
            componentRestrictions: { country: ["uk"] },
            fields: ["address_components", "geometry"],
            types: ["route", "postal_code", 'postal_town'],
        });
        
        autocomplete.addListener("place_changed", function() {
            const place = autocomplete.getPlace().address_components;
            console.log(autocomplete.getPlace().address_components);
            let components = {};
            place.forEach((addressComponent) => {
                addressComponent.types.forEach((type) => {
                    components[type] = addressComponent.long_name;
                });
            });
            $('#get-a-price-field-billing-postcode-input').val(components['postal_code']);
            $('#get-a-price-field-billing-address-line-1-input').val(components['street_number']);
            $('#get-a-price-field-billing-address-line-2-input').val(components['route']);
            $('#get-a-price-field-billing-city-input').val(components['postal_town']);
            $('#get-a-price-field-billing-county-input').val(components['administrative_area_level_2']);
            $('#get-a-price-field-billing-zipcode-input').val(components['postal_code']);
        });
    }

    initSelect2()
    {
        import(/* webpackChunkName: "select2" */ '../components/select2').then(() => {
            $(".select2-price").select2({
                placeholder: 'Please Select',
                allowClear: true,
                minimumResultsForSearch: -1
            });
        });
    }

    validateEmail(email)
    {
        const emailPattern = /^[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*@[a-zA-Z0-9]+(?:-[a-zA-Z0-9]+)*(?:\.[a-zA-Z0-9]+(?:-[a-zA-Z0-9]+)*)+$/;
        if(email.match(emailPattern)) {
            return true;
        }
        return false;
    }

    formatPhoneField(field)
    {
        var input = $(field).val().replace(/\D/g, ''); // Remove all non-digit characters
        var formattedInput = '';
        if (input.length > 0) {
            formattedInput += input.substring(0, 5);
        }
        if (input.length >= 6) {
            formattedInput += ' ' + input.substring(5, 11);
        }
        $(field).val(formattedInput);
    }

    validateFile()
    {
        if($('#get-a-price-field-photo-id-input').get(0).files.length > 0 && $('#get-a-price-field-proof-of-address-input').get(0).files.length > 0)
        {
            var allowedExtensions = ['jpg', 'jpeg', 'png', 'pdf', 'heif', 'heic'];
            var filePhotoID = $('#get-a-price-field-photo-id-input').get(0).files[0].name;
            var fileAddressProof = $('#get-a-price-field-proof-of-address-input').get(0).files[0].name;
            var photoExt = filePhotoID.split('.').pop().toLowerCase();
            var addressExt = fileAddressProof.split('.').pop().toLowerCase();
            console.log(photoExt + ' ' + addressExt);
            if(!allowedExtensions.includes(photoExt) || !allowedExtensions.includes(addressExt)) {
                alert("Uploaded filetype not suported. Please upload jpg, jpeg, png, pdf, heic and heif type file only.");
                return false;
            }
        }
        return true;
    }
    validatePaymentDetails()
    {
        if($('#get-a-price-field-authorised-to-setup-dd-input').prop('checked') == false)
        {
            alert("You must authorise direct debit setup.");
        }else if($('#get-a-price-field-account-holder-input').val() == '')
        {
            alert("Please enter account holder name.");
        }else if($('#get-a-price-field-account-number-input').val() == '')
        {
            alert("Please enter account number.");
        }else if($('#get-a-price-field-sort-code-input').val() == '')
        {
            alert("Please enter sort code.");
        }else{
            return true;
        }
        return false;
    }

    validateBillingAddress()
    {
        if($('#get-a-price-field-billing-address-line1-input').val() == '')
        {
            alert("Please enter your billing address.");
        }else if($('#get-a-price-field-billing-city-input').val() == '')
        {
            alert("Please enter your billing city.");
        }else if($('#get-a-price-field-billing-zipcode-input').val() == '')
        {
            alert("Please enter your billing postcode.");
        }else{
            return true;
        }
        return false;
    }

}

new Getprice;
export { Getprice };